module.exports = __webpack_public_path__ + "img/Weapon_37.e6f72f8d.png";